export default {
  title: 'Study Management',
  createStudy: 'Create a New Study',
  updateStudy: 'Update Study',
  manageSites: 'Manage Sites',
  selectSite: 'Please select a site!',
};
